import { Paper } from "@mui/material";
import { AreaChart, Area, XAxis, YAxis, Tooltip, ResponsiveContainer } from "recharts";
import './chart.css';

interface StackedAreaChartProps {
  data: any;
  theme: any;
}

const CustomTooltip = (props: any) => {
  const { active, payload, label, data, color, theme } = props;
  if (active && payload && payload.length) {
    // Get the hovered section's data; the label is given by the library as the hovered section's name
    const object = data.filter((item) => {return(item.name === label)})
    // Return the data we seek to know about this in a small Paper (elevated shadowed UI) form.
    return (
      <>
        { (object && object.length > 0) &&
          <Paper className="p-2" elevation={1} style={{backgroundColor: theme.colors.dark, opacity: 0.9}}>
            <p className="label" style={{color: color}}>{`${object[0].unclassified.text}: ${object[0].unclassified.count}`}</p>
            <p className="label" style={{color: color}}>{`${object[0].fatal.text}: ${object[0].fatal.count}`}</p>
            <p className="label" style={{color: color}}>{`${object[0].critical.text}: ${object[0].critical.count}`}</p>
            <p className="label" style={{color: color}}>{`${object[0].high.text}: ${object[0].high.count}`}</p>
            <p className="label" style={{color: color}}>{`${object[0].medium.text}: ${object[0].medium.count}`}</p>
            <p className="label" style={{color: color}}>{`${object[0].low.text}: ${object[0].low.count}`}</p>
            <p className="label" style={{color: color}}>{`${object[0].informative.text}: ${object[0].informative.count}`}</p>
          </Paper>
        }
      </>
    );
  }
  return null;
};

const StackedAreaChart = ({data, theme}: StackedAreaChartProps) => {
  return (
    <ResponsiveContainer height={300}>
      <AreaChart
        width={500}
        height={300}
        data={data}
        margin={{
          top: 10,
          right: 30,
          left: 0,
          bottom: 0,
        }}
      >
        <XAxis 
          dy={0} dx={0} dataKey="name" angle={-90} 
          tickLine={false}
          type="category"
          height={110}
          stroke={theme.colors.textColor}
          interval={0}
          textAnchor= "end"
          />
        <YAxis 
          stroke={theme.colors.textColor}
        />
        <Tooltip content={<CustomTooltip data={data} color={theme.colors.textColor} theme={theme}/>} cursor={{fill: 'transparent'}}/>
        <Area
          type="monotone"
          dataKey="unclassified.count"
          stackId="unclassified"
          stroke={theme.colors.unclassified_criticality}
          fill={theme.colors.unclassified_criticality}
        />
        <Area
          type="monotone"
          dataKey="informative.count"
          stackId="informative"
          stroke={theme.colors.informative_criticality}
          fill={theme.colors.informative_criticality}
        />
        <Area
          type="monotone"
          dataKey="fatal.count"
          stackId="fatal"
          stroke={theme.colors.fatal_criticality}
          fill={theme.colors.fatal_criticality}
        />
        <Area
          type="monotone"
          dataKey="critical.count"
          stackId="critical"
          stroke={theme.colors.critical_criticality}
          fill={theme.colors.critical_criticality}
        />
        <Area
          type="monotone"
          dataKey="high.count"
          stackId="high"
          stroke={theme.colors.high_criticality}
          fill={theme.colors.high_criticality}
        />
        <Area
          type="monotone"
          dataKey="medium.count"
          stackId="medium"
          stroke={theme.colors.medium_criticality}
          fill={theme.colors.medium_criticality}
        />
        <Area
          type="monotone"
          dataKey="low.count"
          stackId="low"
          stroke={theme.colors.low_criticality}
          fill={theme.colors.low_criticality}
        />
      </AreaChart>
    </ResponsiveContainer>
  );
};
export default StackedAreaChart;
